import { useMemo, useRef } from 'react';
import { Button, Col, Container, Row } from 'react-bootstrap';
import t from '../../../text';
import { useBreakpointFlags } from '../../hooks/useBreakpointFlags';
import { SearchBox } from '../SearchBox/SearchBox';
import { EnterCodesWrapper, HideIfCodeWordsNotEntered } from '../SearchBox/EnterCodesWrapper';

const HEADER_HEIGHT = 80;
const SCROLL_PADDING = 15;

export const Hero = ({
  heading,
  headingImage,
  subheading,
  mobileBackground = '',
  desktopBackground = '',
  largeDesktopBackground = '',
}) => {
  const { isBelowMd, isAboveMd, isAboveXl } = useBreakpointFlags();

  const buttonRef = useRef(null);

  const isVideo = isBelowMd ? mobileBackground.includes('mp4') : desktopBackground.includes('mp4');

  // Select the right background asset based on width
  const resolvedBackground = useMemo(() => {
    if (isBelowMd) return mobileBackground;
    if (isAboveXl && largeDesktopBackground) return largeDesktopBackground;
    return desktopBackground;
  }, [desktopBackground, isAboveXl, isBelowMd, largeDesktopBackground, mobileBackground]);

  const handleScrollToSearch = () => {
    if (buttonRef.current) {
      buttonRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <Container fluid className="masthead d-flex flex-column px-0 position-relative">
      {!isVideo && resolvedBackground && (
        <img src={resolvedBackground} alt="Hero background" className="masthead-bg-image" loading="eager" />
      )}

      {isBelowMd && isVideo && <Video src={mobileBackground} />}
      {isAboveMd && isVideo && <Video src={desktopBackground} />}

      <Row className="flex-grow-1 mx-0 flex-column h-100">
        <Col className="d-flex flex-column align-items-center text-center text-white mt-4 mt-md-3">
          {headingImage ? (
            <img src={headingImage} className="heading-img" alt={heading} width="90%" loading="eager" />
          ) : (
            <h1 className="text-white mt-2" data-mh-lead>
              {heading}
            </h1>
          )}
          <p className="text-white mb-0 mx-auto" data-mh-sub>
            {subheading}
          </p>
        </Col>

        <EnterCodesWrapper isHomePage >
          <Col className="d-flex flex-column justify-content-end align-items-center">
            <Button
              className="d-md-none mb-4 px-5"
              style={{ scrollMarginTop: HEADER_HEIGHT + SCROLL_PADDING }}
              variant="primary-yellow"
              ref={buttonRef}
              onClick={handleScrollToSearch}
            >
              {t('search.searchNow')}
            </Button>
          </Col>
        </EnterCodesWrapper>
      </Row>

      {isAboveMd && (
        <HideIfCodeWordsNotEntered>
          <Row className="align-self-end bg-primary w-100 mx-0">
            <Col className="py-4 text-white">
              <SearchBox isHomePage />
            </Col>
          </Row>
        </HideIfCodeWordsNotEntered>
      )}
    </Container>
  );
};

const Video = ({ src }) => (
  <video muted autoPlay loop playsInline>
    <source src={src} type="video/mp4" />
  </video>
);
